import { createSelector } from 'reselect';
import { reduxKey } from '../../constants';
import { PapiUser } from '@wix/da-papi-types';

const getReactionUsersState = (state: any) =>
  state[reduxKey]?.reactionUsers || {};

export const getReactionUsers = createSelector(
  [
    getReactionUsersState,
    (_, messageId: string) => messageId,
    (_, __, emoji_id: number) => emoji_id,
  ],
  (reactionUsers, messageId, emoji_id) => {
    return (
      reactionUsers[messageId]?.[emoji_id] || {
        users: [],
        isLoading: false,
        error: null,
      }
    );
  }
);

export const getReactionUsersForMessage = createSelector(
  [getReactionUsersState, (_, messageId: string) => messageId],
  (reactionUsers, messageId) => {
    return reactionUsers[messageId] || {};
  }
);

export const getCurrentUserHasReaction = createSelector(
  [
    getReactionUsersState,
    (_, messageId: string) => messageId,
    (_, __, emoji_id: number) => emoji_id,
    (_, __, ___, currentUser: PapiUser) => currentUser,
  ],
  (reactionUsers, messageId, emoji_id, currentUser) => {
    if (!currentUser?.useridUuid) return false;

    const users = reactionUsers[messageId]?.[emoji_id]?.users || [];
    return users.some(user => user.useridUuid === currentUser.useridUuid);
  }
);
